var _path, _path2, _circle, _circle2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqLowboy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L18 10M18 10L20 8M18 10L18 2.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L21 12",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 18.5,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18.5,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15C1 14.7239 0.776142 14.5 0.5 14.5C0.223858 14.5 0 14.7239 0 15V17.4997C0 18.052 0.447715 18.4997 1 18.4997C1 18.1491 1.06015 17.8125 1.17071 17.4997H1V15ZM6.82929 17.4997C6.93985 17.8125 7 18.1491 7 18.4997C7 18.1491 7.06015 17.8125 7.17071 17.4997H6.82929ZM12.8293 17.4997C12.9398 17.8125 13 18.1491 13 18.4997C13 18.6792 12.9842 18.8551 12.954 19.0259L13.5528 20.2236C13.6375 20.393 13.8106 20.5 14 20.5H22.5H23.5C23.7761 20.5 24 20.2761 24 20C24 19.7239 23.7761 19.5 23.5 19.5H22.5H14.309L13.4472 17.7761C13.3625 17.6067 13.1894 17.4997 13 17.4997H12.8293Z",
    fill: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5L0.5 15H13.1304C13.5089 15 13.855 15.2137 14.0245 15.5522L15 17.5H21.5H22.5H23.5V20",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqLowboy);
export default __webpack_public_path__ + "static/media/eq-lowboy.8e7254f76c5c2107760f4eeee5c5434f.svg";
export { ForwardRef as ReactComponent };